import * as React from "react";

const Plus = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_9366_90795)">
                <path d="M12.6663 8.66671H8.66634V12.6667H7.33301V8.66671H3.33301V7.33337H7.33301V3.33337H8.66634V7.33337H12.6663V8.66671Z" fill="currentColor"/>
            </g>
        </svg>
    );
};

export default React.memo(Plus);
